import * as React from "react";
const SvgFiRrLawyerMan = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-lawyer-man_svg__a)">
      <path
        fill="#062147"
        d="M24 18.664V19a2.002 2.002 0 0 1-2.335 1.973C20.681 20.813 20 19.89 20 18.894v-.23l.854-2.42L19 15.896v6.105h2a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2h2v-6.48l-1.752-.328.861 2.406v.575h-.013a2.056 2.056 0 0 1-2.466 1.783c-.97-.194-1.63-1.112-1.63-2.101v-.244l1.06-3.379a1.66 1.66 0 0 1 1.886-1.135l2.054.381v-.48a1 1 0 1 1 2 0v.851l2.41.447a1.93 1.93 0 0 1 1.465 1.245l1.124 3.121zM3 6c0-3.309 2.691-6 6-6s6 2.691 6 6-2.691 6-6 6-6-2.691-6-6m2 0c0 2.206 1.794 4 4 4s4-1.794 4-4-1.794-4-4-4-4 1.794-4 4m4 8c-4.962 0-9 4.037-9 9a1 1 0 1 0 2 0c0-3.859 3.14-7 7-7a1 1 0 1 0 0-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-lawyer-man_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLawyerMan;
